<app-loading-spinner
  *ngIf="loadingSpinnerService.loading$ | async"></app-loading-spinner>
<div class="tab-content">
  <div class="header" *ngIf="managedPlaygroundIds.length > 1">
    <div class="header-left">
    <!-- Playground multi-select filter -->
    <div>
      <!-- <div class="graph-wrapper" style="margin-bottom: 16px;"> -->
        <div class="d-flex justify-content-between align-items-center">
          <div class="dropdown" data-bs-auto-close="outside" style="margin-left: 8px; position: relative;">
            <button class="btn btn-outline-secondary dropdown-toggle p-0" type="button" id="playgroundFilterDropdown"
            data-bs-toggle="dropdown" aria-expanded="false"
              (click)="togglePlaygroundFilterDropdown()">
              {{ getPlaygroundSelectionLabel() }}
            </button>
            <ul class="dropdown-menu p-0" [ngClass]="{ 'show': isPlaygroundFilterOpen }" aria-labelledby="playgroundFilterDropdown"
              style="min-width: 200px; border-radius: 8px; border-bottom: 0; left: auto; max-height: 320px; overflow: auto;" (click)="$event.stopPropagation()">
              <li>
                <div class="form-check">
                  <label class="form-check-label" for="pg-all">All</label>
                  <input class="form-check-input" type="checkbox" id="pg-all"
                     [checked]="tempAllSelectedPlaygrounds"
                    (change)="onToggleAllPlaygrounds($event.target.checked)" />
                </div>
              </li>
              <li *ngFor="let pg of managedPlaygroundIds">
                <div class="form-check">
                  <label class="form-check-label" [for]="'pg-' + pg.id">{{ pg.name }}</label>
                  <input class="form-check-input" type="checkbox" [id]="'pg-' + pg.id"
                     [checked]="tempAllSelectedPlaygrounds || tempSelectedPlaygroundIds.has(pg.id)"
                    (change)="onToggleOnePlayground(pg.id, $event.target.checked)" />
                </div>
              </li>
              <div class="text-center">
                <button class="btn-apply" type="button" (click)="applyPlaygroundSelection()" [disabled]="!tempAllSelectedPlaygrounds && tempSelectedPlaygroundIds.size === 0">Apply</button>
              </div>
            </ul>
          </div>
        <!-- </div> -->
      </div>
    </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <div class="graph-wrapper">
        <div class="graph-card-header">
          <div class="graph-card-top">
            <div class="d-flex align-items-center">
              <img src="../../../assets/images/HandPointing.svg" alt="" />
              <h3 class="mb-0 ms-2">Story opened</h3>
            </div>
            <div style="position: relative;">
              <select
                id="timeframe"
                [(ngModel)]="selectedTimeframeLine" 
                (change)="updateLineChart(); selectedTimeframeLine === 'custom1' ? lineChartDateRangePicker.click() : null"
              >
                <option value="last7days">Last 7 days</option>
                <option value="last30days">Last 30 days</option>
                <option value="last12Months">Last 12 Months</option>
                <option value="custom1" >Custom</option>
                <option value="custom" *ngIf="selectedTimeframeLine === 'custom'">{{ lineChartCustomDateRangeLabel }}</option>
              </select>
              <div style="position: relative;">
                <input
                #lineChartDateRangePicker
                style="visibility: hidden; display: block; height: 0; width: 0;"
                type="text"
                id="lineChartDateRangePicker"
                placeholder="Select Date Range"
                readonly
                class="date-range-input"
              >
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center graph-numbers">
            <h4 class="d-flex align-items-center" style="border-right: 1px solid rgba(218, 218, 218, 1);">
              Event <br> Count <span>{{ totalLineChartEvents }}</span>
            </h4>
            <h4 class="d-flex align-items-center">
              Total <br> users <span>{{ totalLineChartUsers }}</span>
            </h4>
          </div>
        </div>

        <div style="display: block">
          <canvas
            baseChart
            [datasets]="lineChartData"
            [labels]="lineChartLabels"
            [options]="lineChartOptions"
            [type]="lineChartType"
          >
          </canvas>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="graph-wrapper">
        <div class="graph-card-header">
          <div class="graph-card-top">
            <div class="d-flex align-items-center">
              <img src="../../../assets/images/HandPointing.svg" alt="" />
              <h3 class="mb-0 ms-2">Business button tap</h3>
            </div>
            <div>
              <select
                id="timeframe"
                [(ngModel)]="selectedTimeframeBar"
                (change)="updateBarChart(); selectedTimeframeBar === 'custom1' ? barChartDateRangePicker.click() : null">
                <option value="last7days">Last 7 days</option>
                <option value="last30days">Last 30 days</option>
                <option value="last12Months">Last 12 Months</option>
                <option value="custom1">Custom</option>
                <option style="visibility: hidden;" value="custom" *ngIf="selectedTimeframeBar === 'custom'">{{ barChartCustomDateRangeLabel }}</option>
              </select>
              <div style="position: relative;">
                <input
                  #barChartDateRangePicker
                  style="visibility: hidden; display: block; height: 0; width: 0;"
                  type="text"
                  id="barChartDateRangePicker"
                  placeholder="Select Date Range"
                  readonly
                  class="date-range-input">
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center graph-numbers">
            <h4 class="d-flex align-items-center" style="border-right: 1px solid rgba(218, 218, 218, 1)">
              Event <br> Count <span>{{ totalBarChartEvents }}</span>
            </h4>
            <h4 class="d-flex align-items-center">
              Total <br> users <span>{{ totalBarChartUsers }}</span>
            </h4>
          </div>
        </div>

        <div style="display: block">
          <canvas
            baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [type]="barChartType"
          >
          </canvas>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="analytics-wrapper">
        <div class="d-flex align-items-start">
          <div class="not-img me-3">
            <img src="../../../assets/images/users.svg" alt="" />
          </div>
          <div>
            <h3>{{totalUsers}}</h3>
            <h4>Total users</h4>
            <h5>
              Total number of users that interacted with the magnets
            </h5>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-md-6">
      <div class="analytics-wrapper">
        <div class="d-flex align-items-start">
          <div class="not-img me-3">
            <img src="../../../assets/images/notification-ring.svg" alt="" />
          </div>
          <div>
            <h3>{{ notificationOpened }}</h3>
            <h4>Notification opened</h4>
            <h5>Number of notifications opened.</h5>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
